/**
 * Transaction Processing Dashboard - Module Exports
 * Barrel export file for the dashboard component and its routes
 * @module TransactionProcessingDashboard
 * @version 1.0.0
 */

import type { RouteRecordRaw } from 'vue-router'

// Component exports
export { default as ErrorSummaryTable } from './components/ErrorSummaryTable.vue'
export { default as TransactionFilters } from './components/TransactionFilters.vue'
export { default as TransactionTable } from './components/TransactionTable.vue'
export { default as TransmissionTable } from './components/TransmissionTable.vue'
export { default as TransmissionTimeline } from './components/TransmissionTimeline.vue'
// TransactionProcessingDashboard is only exported via dynamic imports in routes for code splitting

// Composable exports
export { useTransactionDashboard } from './composables/useTransactionDashboard'

// Type exports
export type * from './types'

/**
 * Dashboard routes configuration for Vue Router
 * These routes should be added to your main router configuration
 */
export const transactionDashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/transaction-dashboard',
    name: 'TransactionDashboard',
    component: () => import('./TransactionProcessingDashboard.vue'),
    meta: {
      title: 'Transaction Processing Dashboard',
      requiresAuth: true,
      permissions: ['view-transactions', 'manage-transmissions'],
      breadcrumb: [
        { label: 'Dashboard', to: '/' },
        { label: 'Transaction Processing', to: '/transaction-dashboard' },
      ],
    },
  },
  {
    path: '/transaction-dashboard/transaction/:id',
    name: 'TransactionDetails',
    component: () => import('./TransactionProcessingDashboard.vue'),
    props: true,
    meta: {
      title: 'Transaction Details',
      requiresAuth: true,
      permissions: ['view-transactions'],
      breadcrumb: [{ label: 'Dashboard', to: '/' }, { label: 'Transaction Processing', to: '/transaction-dashboard' }, { label: 'Transaction Details' }],
    },
  },
]

/**
 * Navigation menu item for sidebar integration
 */
export const dashboardMenuItem = {
  label: 'Transaction Dashboard',
  icon: 'dashboard',
  to: '/transaction-dashboard',
  children: [
    {
      label: 'Overview',
      icon: 'analytics',
      to: '/transaction-dashboard',
    },
    {
      label: 'Queue Monitor',
      icon: 'queue',
      to: '/transaction-dashboard?tab=queue',
    },
    {
      label: 'Error Logs',
      icon: 'bug_report',
      to: '/transaction-dashboard?tab=errors',
    },
  ],
}

/**
 * Default export - main dashboard component
 * Note: Use dynamic import in routes for code splitting
 */
export { transactionDashboardRoutes as default }
